import React, { useState, useEffect } from 'react';
import { Modal, BlockStack, TextField } from '@shopify/polaris';
import { ordersService } from '../../services/ordersService';

const EditShippingAddressModal = ({
    isOpen,
    onClose,
    order,
    onOrderUpdated,
    setToastMessage,
    setToastActive
}) => {
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        address1: '',
        address2: '',
        city: '',
        phone: '',
        governorate: ''
    });

    useEffect(() => {
        if (order && isOpen) {
            const shipping = order.shipping_address || {};
            // Fallback to customer address if shipping address is empty
            const customer = order.customer || {};

            setFormData({
                address1: shipping.address1 || customer.address1 || '',
                address2: shipping.address2 || customer.address2 || '',
                city: shipping.city || customer.city || '',
                phone: shipping.phone || customer.phone || '',
                governorate: shipping.governorate || customer.province_code || '' // Map province_code to governorate if needed, or just keep empty
            });
        }
    }, [order, isOpen]);

    const handleSubmit = async () => {
        setLoading(true);
        try {
            await ordersService.updateShippingAddress(order.order_id, formData);
            setToastMessage('Shipping address updated successfully');
            setToastActive(true);
            if (onOrderUpdated) onOrderUpdated();
            onClose();
        } catch (error) {
            setToastMessage(error.message || 'Failed to update shipping address');
            setToastActive(true);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal
            open={isOpen}
            onClose={onClose}
            title="Edit Shipping Address"
            primaryAction={{
                content: 'Save',
                onAction: handleSubmit,
                loading: loading,
            }}
            secondaryActions={[
                {
                    content: 'Cancel',
                    onAction: onClose,
                    disabled: loading,
                },
            ]}
        >
            <Modal.Section>
                <BlockStack gap="400">
                    <TextField
                        label="Street Address (Line 1)"
                        value={formData.address1}
                        onChange={(value) => setFormData(prev => ({ ...prev, address1: value }))}
                        autoComplete="address-line1"
                    />
                    <TextField
                        label="Apartment, suite, etc. (Line 2)"
                        value={formData.address2}
                        onChange={(value) => setFormData(prev => ({ ...prev, address2: value }))}
                        autoComplete="address-line2"
                    />
                    <TextField
                        label="City"
                        value={formData.city}
                        onChange={(value) => setFormData(prev => ({ ...prev, city: value }))}
                        autoComplete="address-level2"
                    />
                    <TextField
                        label="Governorate"
                        value={formData.governorate}
                        onChange={(value) => setFormData(prev => ({ ...prev, governorate: value }))}
                        autoComplete="address-level1"
                    />
                    <TextField
                        label="Phone"
                        value={formData.phone}
                        onChange={(value) => setFormData(prev => ({ ...prev, phone: value }))}
                        autoComplete="tel"
                        inputMode="tel"
                    />
                </BlockStack>
            </Modal.Section>
        </Modal>
    );
};

export default EditShippingAddressModal;
